/**
 * Mega Menu 3 kolumny - Custom JavaScript
 * Author: Claude Code
 * Date: 2025-11-05
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const megaMenu = document.querySelector('.mega-menu-wrapper');
    if (!megaMenu) return;

    // Mobile menu toggle
    setupMobileMenu();

    // Desktop hover delays
    setupDesktopMenu();

    // Keyboard navigation
    setupKeyboardNav();

    // Close on outside click
    setupOutsideClick();
  }

  /**
   * Mobile menu accordion behavior
   */
  function setupMobileMenu() {
    const menuItems = document.querySelectorAll('.has-mega-dropdown');

    menuItems.forEach(item => {
      const link = item.querySelector('.mega-menu-link');

      link.addEventListener('click', function(e) {
        // Only prevent default on mobile
        if (window.innerWidth <= 768) {
          e.preventDefault();

          // Close other open items
          menuItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('active');
            }
          });

          // Toggle current item
          item.classList.toggle('active');
        }
      });
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Close all dropdowns on resize
        menuItems.forEach(item => {
          item.classList.remove('active');
        });
      }, 250);
    });
  }

  /**
   * Desktop hover with delay
   */
  function setupDesktopMenu() {
    const menuItems = document.querySelectorAll('.has-mega-dropdown');
    let hoverTimer;

    menuItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        if (window.innerWidth > 768) {
          clearTimeout(hoverTimer);
          // Small delay before opening
          hoverTimer = setTimeout(() => {
            item.classList.add('hovered');
          }, 100);
        }
      });

      item.addEventListener('mouseleave', function() {
        if (window.innerWidth > 768) {
          clearTimeout(hoverTimer);
          // Small delay before closing
          hoverTimer = setTimeout(() => {
            item.classList.remove('hovered');
          }, 200);
        }
      });
    });
  }

  /**
   * Keyboard navigation (accessibility)
   */
  function setupKeyboardNav() {
    const menuItems = document.querySelectorAll('.has-mega-dropdown');

    menuItems.forEach(item => {
      const link = item.querySelector('.mega-menu-link');

      link.addEventListener('keydown', function(e) {
        // Open on Enter or Space
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.classList.toggle('active');
        }

        // Close on Escape
        if (e.key === 'Escape') {
          item.classList.remove('active');
          link.focus();
        }
      });
    });

    // Close dropdown when tabbing out
    document.addEventListener('focusin', function(e) {
      const activeItem = document.querySelector('.has-mega-dropdown.active');
      if (activeItem && !activeItem.contains(e.target)) {
        activeItem.classList.remove('active');
      }
    });
  }

  /**
   * Close dropdown when clicking outside
   */
  function setupOutsideClick() {
    document.addEventListener('click', function(e) {
      const megaMenu = document.querySelector('.mega-menu-wrapper');

      if (megaMenu && !megaMenu.contains(e.target)) {
        const activeItems = document.querySelectorAll('.has-mega-dropdown.active');
        activeItems.forEach(item => {
          item.classList.remove('active');
        });
      }
    });
  }

  /**
   * Smooth scroll to collection (optional enhancement)
   */
  function setupSmoothScroll() {
    const links = document.querySelectorAll('.mega-menu-list a');

    links.forEach(link => {
      link.addEventListener('click', function(e) {
        // Close mobile menu after click
        if (window.innerWidth <= 768) {
          const parentItem = this.closest('.has-mega-dropdown');
          if (parentItem) {
            setTimeout(() => {
              parentItem.classList.remove('active');
            }, 300);
          }
        }
      });
    });
  }

  setupSmoothScroll();

})();
